import axios from "axios";
import { API_URL } from "@/utils/const";
import authHeader from "@/services/data.service";

export const LocalAuth = {
  login(credentials) {
    return axios
      .post(API_URL + "auth/signin", {
        username: credentials.username,
        password: credentials.password,
      })
      .then((response) => {
        localStorage.setItem("user", JSON.stringify(response.data));
        return response.data; })
      .catch((error) => {
        console.log(`Error in sending the login request ${error}`);
      });
  },
  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("fields");
  },
  async role() {
    return axios
      .get(API_URL + "auth", {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.data.data) {
          return {
            role: response.data.data.role,
            cons: response.data.data.cons
          };
        }
      })
      .catch(() => {
        return null;
      });
  }
}
